import { apiInstance_ecom } from "@/app/api-config/axios-instance";
import ServiceBase from "../service/ServiceBase";

const ENDPOINTS = {
  ORDER_LIST: "/order/orderList",
  ORDER_DETAILS: "/order/orderDetails",
  ADD_ADDRESS: "/addAddress",
  APPLY_COUPON: "order/checkCouponUsability",
  GET_ADMIN_ACC_DETAILS: "/getAdminAccountDetail",
  PARTIAL_ORDER: "/order/partialOrderList",
  FULL_CREDIT: "/order/fullCredit",
  MODIFY_ORDER: "/order/modifyOrder",
  REQUEST_REFUND: "/order/refundrequestmail",
};

export function checkCouponUsability({ payload, couponCode }) {
  const response = apiInstance_ecom.post(`/order/checkCouponUsability/?couponCode=${couponCode}`, payload, {
    skipLoader: true,
  });
  return response;
}
class OrderManagementService extends ServiceBase {
  // async _handleAPICall(
  //   endpoint = "",
  //   params = {},
  //   method = "get",
  //   flag = false
  // ) {
  //   try {
  //     const response = await apiInstance_ecom[method](
  //       endpoint,
  //       flag
  //         ? { params }
  //         : {
  //             ...params,
  //           }
  //     );
  //     return ["Created", "OK"].includes(response.statusText)
  //       ? response.data
  //       : null;
  //   } catch (error) {
  //     console.log(error);
  //     console.error(error?.data?.message);
  //     return error;
  //   }
  // }
  // Modified method to accept query parameters
  getOrdersList(queryParams = {}) {
    // Convert arrays (like `orderStatus`) to a URL-encoded JSON string
    const encodedParams = {
      ...queryParams,
      orderStatus: queryParams.orderStatus ? JSON.stringify(queryParams.orderStatus) : undefined,
    };

    return this._handleAPICall(ENDPOINTS.ORDER_LIST, encodedParams, "get", true);
  }

  // Other methods remain unchanged
  getOrderDetails(id) {
    if (id) {
      return this._handleAPICall(ENDPOINTS.ORDER_DETAILS, { order_id: id }, "get", true);
    }
  }

  addUserAddress(payload) {
    return this._handleAPICall(
      ENDPOINTS.ADD_ADDRESS,
      {
        ...payload,
      },
      "post"
    );
  }

  getAdminAccountDetails() {
    return this._handleAPICall(ENDPOINTS.GET_ADMIN_ACC_DETAILS, "get");
  }

  applyCoupon({ payload, couponCode }) {
    return this._handleAPICall(`${ENDPOINTS.APPLY_COUPON}/?couponCode=${couponCode}`, payload, "post");
  }
  getPartialOrderDetails(orderId) {
    return this._handleAPICall(`${ENDPOINTS.PARTIAL_ORDER}?orderId=${orderId}`, "get");
  }
  getFullCredit(orderId) {
    return this._handleAPICall(
      ENDPOINTS.FULL_CREDIT,
      {
        order_id: orderId,
      },
      "put"
    );
  }
  modifyOrder(payload) {
    return this._handleAPICall(
      ENDPOINTS.MODIFY_ORDER,
      {
        ...payload,
      },
      "put"
    );
  }
  requestRefund(payload) {
    return this._handleAPICall(
      ENDPOINTS.REQUEST_REFUND,
      {
        ...payload,
      },
      "post"
    );
  }
}

const orderService = new OrderManagementService();
export default orderService;
